<template>
  <div style="padding: 10px">
    <!-- PC端搜索区域 -->
    <div class="search-pc" style="margin: 10px 0; display: flex; align-items: center; flex-wrap: wrap; gap: 10px;">
      <el-select v-model="search.roleId" placeholder="请选择用户" filterable remote clearable
          :remote-method="handleSearchAccountInfo" :loading="searchAccountLoading"
          @focus="handleAccountSelectFocus" style="width: 200px">
        <el-option v-for="item in accountInfoOptions" :key="item.roleId" :label="item.accountName" :value="item.roleId">
          <span>{{ item.accountName }} ({{ item.roleId }})</span>
        </el-option>
      </el-select>
      <el-select v-model="search.type" placeholder="交易情况" clearable style="width: 150px">
        <el-option label="销售额" :value="0"></el-option>
        <el-option label="支出" :value="1"></el-option>
        <el-option label="未结算" :value="2"></el-option>
        <el-option label="已结算" :value="3"></el-option>
      </el-select>
      <el-select v-model="search.roleParentId" placeholder="按父ID查询" filterable remote clearable
          :remote-method="handleSearchAccountInfo" :loading="searchAccountLoading"
          @focus="handleAccountSelectFocus" style="width: 200px">
        <el-option v-for="item in accountInfoOptions" :key="item.roleId" :label="item.accountName" :value="item.roleId">
          <span>{{ item.accountName }} ({{ item.roleId }})</span>
        </el-option>
      </el-select>
      <el-button type="primary" @click="load">查询</el-button>
      <el-button @click="resetData">重置</el-button>
      <el-button type="primary" @click="handleAdd">新增</el-button>
      <el-button type="success" @click="calculateStatistics">计算</el-button>
      <el-divider direction="vertical"></el-divider>
      <el-button v-for="btn in quickFilterButtons" :key="btn.name" size="small" @click="quickCalculate(btn.roleParentId, btn.name)">
        {{ btn.name }}
      </el-button>
    </div>

    <!-- 移动端搜索 -->
    <div class="search-mobile">
      <div class="search-header" @click="searchCollapsed = !searchCollapsed">
        <span>搜索筛选</span>
        <i :class="searchCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
      </div>
      <div class="search-content" v-show="!searchCollapsed">
        <el-select v-model="search.roleId" placeholder="请选择用户" filterable remote clearable
            :remote-method="handleSearchAccountInfo" :loading="searchAccountLoading"
            @focus="handleAccountSelectFocus">
          <el-option v-for="item in accountInfoOptions" :key="item.roleId" :label="item.accountName" :value="item.roleId">
            <span>{{ item.accountName }} ({{ item.roleId }})</span>
          </el-option>
        </el-select>
        <el-select v-model="search.type" placeholder="交易情况" clearable>
          <el-option label="销售额" :value="0"></el-option>
          <el-option label="支出" :value="1"></el-option>
          <el-option label="未结算" :value="2"></el-option>
          <el-option label="已结算" :value="3"></el-option>
        </el-select>
        <el-select v-model="search.roleParentId" placeholder="按父ID查询" filterable remote clearable
            :remote-method="handleSearchAccountInfo" :loading="searchAccountLoading"
            @focus="handleAccountSelectFocus">
          <el-option v-for="item in accountInfoOptions" :key="item.roleId" :label="item.accountName" :value="item.roleId">
            <span>{{ item.accountName }} ({{ item.roleId }})</span>
          </el-option>
        </el-select>
        <div class="search-btns">
          <el-button type="primary" @click="load">查询</el-button>
          <el-button @click="resetData">重置</el-button>
        </div>
      </div>
      <div class="action-btns">
        <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        <el-button type="success" size="small" @click="calculateStatistics">计算</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button v-for="btn in quickFilterButtons" :key="btn.name" size="small" @click="quickCalculate(btn.roleParentId, btn.name)">
          {{ btn.name }}
        </el-button>
      </div>
    </div>

    <!-- 统计数据显示 -->
    <div v-if="showStatistics" class="statistics-box">
      <!-- 计算按钮显示 -->
      <div v-if="!isQuickCalculate" class="statistics-row">
        <div class="stat-item"><span class="stat-label">总支出：</span><span class="stat-value expense">{{ statistics.outMoney }}元</span></div>
        <div class="stat-item"><span class="stat-label">总交易额：</span><span class="stat-value income">{{ statistics.inMoney }}元</span></div>
        <div class="stat-item"><span class="stat-label">利润：</span><span class="stat-value" :style="{ color: (statistics.income || 0) < 0 ? '#f56c6c' : '#67c23a' }">{{ statistics.income }}元</span></div>
      </div>
      <!-- 快捷按钮显示 -->
      <div v-else class="statistics-row">
        <div class="stat-item"><span class="stat-label">未结算：</span><span class="stat-value pending">{{ statistics.otherMoney }}元</span></div>
        <div class="stat-item"><span class="stat-label">已结算：</span><span class="stat-value pending">{{ statistics.otherEndMoney }}元</span></div>
        <div class="stat-item"><span class="stat-label">合计：</span><span class="stat-value profit">{{ statistics.income }}元</span></div>
        <div class="stat-item">
          <el-button type="warning" size="small" @click="showBatchSettleDialog">一键结算</el-button>
        </div>
      </div>
      <div v-if="orderDetails && orderDetails.length > 0" class="details-section">
        <div class="details-title">未结算明细（按父ID分组）：</div>
        <div class="details-list">
          <div v-for="(item, index) in orderDetails" :key="index" class="detail-item">
            <span class="detail-name">{{ item.roleParentName || item.roleParentId || '未知' }}</span>
            <span class="detail-money">{{ formatNumber(item.money) }}元</span>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端表格区域 -->
    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" class="table-pc">
      <el-table-column prop="accountName" label="角色名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="roleId" label="角色ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="price" label="交易金额" show-overflow-tooltip>
        <template #default="scope">{{ formatNumber(scope.row.price) }}</template>
      </el-table-column>
      <el-table-column prop="type" label="交易情况" show-overflow-tooltip>
        <template #default="scope">
          <el-tag :type="getTypeTagType(scope.row.type)">{{ getTypeText(scope.row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="event" label="说明" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="160px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" @click="end(scope.row)">结算</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 移动端卡片 -->
    <div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <span class="card-label">角色名：</span>
          <span class="card-value">{{ item.accountName }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">交易金额：</span>
          <span class="card-value">{{ formatNumber(item.price) }}元</span>
        </div>
        <div class="card-row">
          <span class="card-label">交易情况：</span>
          <el-tag size="small" :type="getTypeTagType(item.type)">{{ getTypeText(item.type) }}</el-tag>
        </div>
        <div class="card-row">
          <span class="card-label">说明：</span>
          <span class="card-value">{{ item.event }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">时间：</span>
          <span class="card-value">{{ item.createTime }}</span>
        </div>
        <div class="card-actions" v-if="userId === 1">
          <el-button size="small" @click="handleEdit(item)">编辑</el-button>
          <el-button size="small" @click="end(item)">结算</el-button>
        </div>
      </div>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-wrapper">
      <el-pagination class="pagination-pc" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-pagination class="pagination-mobile" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

    <!-- 新增编辑表单 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="30%" class="form-dialog">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" class="dialog-form">
        <el-form-item v-if="!form.id" label="账号" prop="roleId" required>
          <el-select v-model="form.roleId" placeholder="请选择账号" filterable remote clearable
              :remote-method="handleSearchAccountInfo" :loading="searchAccountLoading"
              @focus="handleAccountSelectFocus" @change="handleAccountChange" style="width: 100%">
            <el-option v-for="item in accountInfoOptions" :key="item.roleId" :label="item.accountName" :value="item.roleId">
              <span>{{ item.accountName }} ({{ item.roleId }})</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.id" label="角色名">
          <el-input v-model="form.accountName" readonly></el-input>
        </el-form-item>
        <el-form-item v-if="form.id" label="角色ID">
          <el-input v-model="form.roleId" readonly></el-input>
        </el-form-item>
        <el-form-item label="交易金额" prop="price" required>
          <el-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%" placeholder="请输入交易金额"></el-input-number>
        </el-form-item>
        <el-form-item label="交易情况" prop="type" required>
          <el-select v-model="form.type" placeholder="请选择交易情况" style="width: 100%">
            <el-option label="销售额" :value="0"></el-option>
            <el-option label="支出" :value="1"></el-option>
            <el-option label="未结算" :value="2"></el-option>
            <el-option label="已结算" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" prop="event">
          <el-input v-model="form.event" type="textarea" :rows="2" placeholder="请输入说明"></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="createTime" required>
          <el-date-picker v-model="form.createTime" type="datetime" placeholder="选择日期时间" style="width: 100%" value-format="YYYY-MM-DD HH:mm:ss"></el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 一键结算弹窗 -->
    <el-dialog title="一键结算确认" v-model="batchSettleDialogVisible" width="400px">
      <div style="text-align: center; padding: 20px 0;">
        <p style="font-size: 16px; margin-bottom: 20px;">确定将 <strong>{{ batchSettleCount }}</strong> 条未结算记录标记为已结算？</p>
        <el-progress v-if="batchSettleProgress.total > 0" :percentage="batchSettleProgress.percentage" :status="batchSettleProgress.status"></el-progress>
        <div v-if="batchSettleProgress.total > 0" style="margin-top: 10px; font-size: 12px; color: #909399;">
          {{ batchSettleProgress.current }} / {{ batchSettleProgress.total }}
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="batchSettleDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="executeBatchSettle" :loading="batchSettleLoading">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'LegacySoldOrderManagement',
  data() {
    return {
      userId: '',
      loading: true,
      search: { roleId: '', type: '', roleParentId: '', types: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增',
      form: { id: null, accountName: '', roleId: '', price: 0, type: 0, event: '', createTime: '' },
      formRef: null,
      accountInfoOptions: [],
      searchAccountLoading: false,
      searchAccountDebounce: null,
      showStatistics: false,
      isQuickCalculate: false,
      statistics: { outMoney: 0, inMoney: 0, otherMoney: 0, otherEndMoney: 0, income: 0 },
      orderDetails: [],
      searchCollapsed: true,
      batchSettleDialogVisible: false,
      batchSettleLoading: false,
      batchSettleCount: 0,
      batchSettleProgress: { current: 0, total: 0, percentage: 0, status: '' },
      quickFilterButtons: [
        { name: '花猪', roleParentId: '73340546' },
        { name: '梓熙', roleParentId: '72344037' },
        { name: '路', roleParentId: '72349012' },
        { name: '炫酷', roleParentId: '66536621' },
        { name: '风云', roleParentId: '66537331' },
        { name: '嗨', roleParentId: '66530770' },
        { name: '随言', roleParentId: '66531838' },
        { name: '带头大哥', roleParentId: '72345660' }
      ],
      rules: {
        roleId: [{required: true, message: '请选择账号', trigger: 'blur'}],
        price: [{required: true, message: '请输入交易金额', trigger: 'blur'}, {type: 'number', min: 0, message: '金额不能为负数', trigger: 'blur'}],
        type: [{required: true, message: '请选择交易情况', trigger: 'change'}],
        createTime: [{required: true, message: '请选择时间', trigger: 'change'}]
      }
    }
  },
  created() {
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
    this.load();
  },
  methods: {
    calculateStatistics() {
      // 重置搜索条件并刷新列表
      this.search = { roleId: '', type: '', roleParentId: '', types: '' };
      this.currentPage = 1;
      this.load();

      // 计算统计数据
      this.loading = true;
      request.get("/legacySoldOrder/computeMoney").then(res => {
        this.loading = false;
        if (res.code === '0') {
          const data = res.data || {};
          this.statistics = {
            outMoney: this.formatNumber(data.outMoney || 0), inMoney: this.formatNumber(data.inMoney || 0),
            otherMoney: this.formatNumber(data.otherMoney || 0), otherEndMoney: this.formatNumber(data.otherEndMoney || 0),
            income: this.formatNumber(data.income || 0)
          };
          this.orderDetails = data.orderDetails || [];
          this.showStatistics = true;
          this.isQuickCalculate = false;  // 标记为计算模式
          this.$message({ type: "success", message: "计算完成" });
        } else { this.$message.error(res.msg || '计算失败'); }
      }).catch(() => { this.loading = false; this.$message.error('网络错误，计算失败'); });
    },
    quickCalculate(roleParentId, name) {
      // 设置搜索条件并刷新列表（只显示已结算和未结算）
      this.search.roleParentId = roleParentId;
      this.search.types = '2,3';  // 只查询未结算和已结算
      this.currentPage = 1;
      this.load();

      // 计算统计数据
      this.loading = true;
      request.get("/legacySoldOrder/listPage", { params: { current: 1, size: 10000, roleParentId: roleParentId } }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          const allData = res.data?.records || res.data?.list || res.data || [];

          if (allData.length === 0) {
            this.$message.warning(`${name} 没有找到记录`);
            this.showStatistics = false;
            return;
          }

          // 只统计未结算和已结算
          let unsettled = 0;  // 未结算 type=2
          let settled = 0;    // 已结算 type=3

          allData.forEach(item => {
            const price = parseFloat(item.price) || 0;
            switch (parseInt(item.type)) {
              case 2: unsettled += price; break;
              case 3: settled += price; break;
            }
          });

          // 更新统计数据显示（只显示未结算、已结算、合计）
          this.statistics = {
            outMoney: 0,
            inMoney: 0,
            otherMoney: this.formatNumber(unsettled),
            otherEndMoney: this.formatNumber(settled),
            income: this.formatNumber(unsettled + settled)
          };
          this.orderDetails = [];
          this.showStatistics = true;
          this.isQuickCalculate = true;  // 标记为快捷计算模式
        } else {
          this.$message.error(res.msg || '获取数据失败');
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('网络错误');
      });
    },
    showBatchSettleDialog() {
      if (!this.search.roleParentId) {
        this.$message.warning('请先点击快捷按钮筛选数据');
        return;
      }
      // 获取未结算记录数量
      this.loading = true;
      request.get("/legacySoldOrder/listPage", { params: { current: 1, size: 10000, roleParentId: this.search.roleParentId, type: 2 } }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          const unsettledData = res.data?.records || res.data?.list || res.data || [];
          this.batchSettleCount = unsettledData.length;

          if (this.batchSettleCount === 0) {
            this.$message.warning('没有需要结算的记录');
            return;
          }

          this.batchSettleProgress = { current: 0, total: 0, percentage: 0, status: '' };
          this.batchSettleDialogVisible = true;
        } else {
          this.$message.error(res.msg || '获取数据失败');
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('网络错误');
      });
    },
    async executeBatchSettle() {
      this.batchSettleLoading = true;
      this.batchSettleProgress = { current: 0, total: 0, percentage: 0, status: '' };

      try {
        // 获取所有未结算记录
        const res = await request.get("/legacySoldOrder/listPage", { params: { current: 1, size: 10000, roleParentId: this.search.roleParentId, type: 2 } });
        if (res.code !== '0') {
          this.$message.error(res.msg || '获取数据失败');
          this.batchSettleLoading = false;
          return;
        }

        const unsettledData = res.data?.records || res.data?.list || res.data || [];
        if (unsettledData.length === 0) {
          this.$message.warning('没有需要结算的记录');
          this.batchSettleLoading = false;
          return;
        }

        this.batchSettleProgress.total = unsettledData.length;
        let successCount = 0;
        let failCount = 0;

        // 循环结算
        for (let i = 0; i < unsettledData.length; i++) {
          const item = unsettledData[i];

          try {
            const updateRes = await request.post("/legacySoldOrder/update", { id: item.id, type: 3 });
            if (updateRes.code === '0') {
              successCount++;
            } else {
              failCount++;
              console.error(`记录 ${item.id} 结算失败:`, updateRes.msg);
            }
          } catch (error) {
            failCount++;
            console.error(`记录 ${item.id} 结算异常:`, error);
          }

          // 更新进度
          this.batchSettleProgress.current = i + 1;
          this.batchSettleProgress.percentage = Math.round((i + 1) / unsettledData.length * 100);
        }

        this.batchSettleProgress.status = 'success';
        this.batchSettleLoading = false;
        this.$message.success(`结算完成！成功 ${successCount} 条，失败 ${failCount} 条`);
        this.batchSettleDialogVisible = false;

        // 刷新列表和统计
        this.quickCalculate(this.search.roleParentId, '');
      } catch (error) {
        this.batchSettleLoading = false;
        this.$message.error('一键结算失败: ' + (error.message || '未知错误'));
      }
    },
    formatNumber(num) { return parseFloat(num.toFixed(2)); },
    getTypeTagType(type) {
      switch (parseInt(type)) { case 0: return 'success'; case 1: return 'danger'; case 2: return 'warning'; case 3: return 'info'; default: return 'info'; }
    },
    getTypeText(type) {
      const typeMap = { 0: '销售额', 1: '支出', 2: '未结算', 3: '已结算' };
      return typeMap[type] || '未知';
    },
    handleAdd() {
      this.dialogTitle = '新增';
      this.form = { id: null, accountName: '', roleId: '', price: 0, type: 0, event: '卖券', createTime: this.getCurrentTime() };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogTitle = '编辑';
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    handleSearchAccountInfo(query) {
      this.searchAccountLoading = true;
      if (this.searchAccountDebounce) clearTimeout(this.searchAccountDebounce);
      this.searchAccountDebounce = setTimeout(() => {
        request.get("/accountInfo/searchAccounts", { params: { accountName: query, limit: 20 } }).then(res => {
          this.searchAccountLoading = false;
          this.accountInfoOptions = res.code === '0' ? res.data : [];
        }).catch(() => { this.searchAccountLoading = false; this.accountInfoOptions = []; });
      }, 300);
    },
    handleAccountSelectFocus() { if (this.accountInfoOptions.length === 0) this.handleSearchAccountInfo(''); },
    handleAccountChange(roleId) {
      if (roleId) {
        const selectedAccount = this.accountInfoOptions.find(item => item.roleId === roleId);
        if (selectedAccount) this.form.accountName = selectedAccount.accountName;
      } else { this.form.accountName = ''; }
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
    },
    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          const formData = {...this.form};
          if (formData.id) {
            const updateData = { id: formData.id, price: formData.price, type: formData.type, event: formData.event, createTime: formData.createTime };
            request.post("/legacySoldOrder/update", updateData).then(res => {
              this.loading = false;
              if (res.code === '0') {
                this.$message({ type: "success", message: "编辑成功" });
                this.dialogVisible = false;
                this.load();
                if (this.showStatistics) this.calculateStatistics();
              } else { this.$message({ type: "error", message: res.msg || "编辑失败" }); }
            }).catch(() => { this.loading = false; this.$message.error("网络错误，编辑失败"); });
          } else {
            request.post("/legacySoldOrder/save", formData).then(res => {
              this.loading = false;
              if (res.code === '0') {
                this.$message({ type: "success", message: "新增成功" });
                this.dialogVisible = false;
                this.load();
                if (this.showStatistics) this.calculateStatistics();
              } else { this.$message({ type: "error", message: res.msg || "新增失败" }); }
            }).catch(() => { this.loading = false; this.$message.error("网络错误，新增失败"); });
          }
        }
      });
    },
    end(row) {
      this.loading = true;
      request.post("/legacySoldOrder/update", { id: row.id, type: 3 }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({ type: "success", message: "结算完成" });
          this.load();
          if (this.showStatistics) this.calculateStatistics();
        } else { this.$message({ type: "error", message: res.msg || "结算失败" }); }
      }).catch(() => { this.loading = false; this.$message.error("网络错误，结算失败"); });
    },
    load() {
      this.loading = true;
      const params = { current: this.currentPage, size: this.pageSize };
      Object.keys(this.search).forEach(key => {
        if (this.search[key] !== '' && this.search[key] !== undefined && this.search[key] !== null) params[key] = this.search[key];
      });
      request.get("/legacySoldOrder/listPage", { params: params }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        } else { this.$message.error(res.msg || '加载失败'); this.tableData = []; this.total = 0; }
      }).catch(() => { this.loading = false; this.$message.error('网络错误，加载失败'); this.tableData = []; this.total = 0; });
    },
    resetData() { this.search = { roleId: '', type: '', roleParentId: '', types: '' }; this.currentPage = 1; this.load(); },
    handleSizeChange(pageSize) { this.pageSize = pageSize; this.currentPage = 1; this.load(); },
    handleCurrentChange(pageNum) { this.currentPage = pageNum; this.load(); }
  }
}
</script>

<style scoped>
/* PC端/移动端显示控制 */
.search-mobile, .table-mobile, .pagination-mobile { display: none; }

/* 移动端搜索样式 */
.search-mobile .search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}

.search-mobile .search-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}

.search-mobile .search-content .el-select { width: 100%; }

.search-mobile .search-btns {
  display: flex;
  gap: 10px;
}

.search-mobile .search-btns .el-button { flex: 1; }

.search-mobile .action-btns {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

/* 统计信息样式 */
.statistics-box {
  margin: 10px 0;
  padding: 15px;
  background: #303133;
  border-radius: 4px;
}

.statistics-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.stat-item { font-size: 14px; }
.stat-label { font-weight: bold; color: #909399; }
.stat-value { font-weight: bold; }
.stat-value.expense { color: #f56c6c; }
.stat-value.income { color: #67c23a; }
.stat-value.pending { color: #e6a23c; }
.stat-value.profit { color: #409eff; }
.stat-value.profit-negative { color: #f56c6c; }
.stat-value.profit-positive { color: #67c23a; }

.details-title { font-weight: bold; color: #909399; margin-bottom: 8px; }
.details-list { display: flex; flex-wrap: wrap; gap: 10px; }
.detail-item {
  display: flex;
  align-items: center;
  background: #404040;
  padding: 8px 15px;
  border-radius: 4px;
}
.detail-name { color: #e6a23c; margin-right: 10px; }
.detail-money { color: #ffffff; font-weight: bold; }

/* 移动端卡片样式 */
.card-item {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
}

.card-row {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
}

.card-label { color: #909399; width: 80px; flex-shrink: 0; }
.card-value { color: #303133; flex: 1; }

.card-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .search-pc, .table-pc, .pagination-pc { display: none !important; }
  .search-mobile, .table-mobile, .pagination-mobile { display: block !important; }

  /* 暗色模式 */
  .search-mobile .search-header {
    background: #2a2a2a;
    color: #e6a23c;
    border: 1px solid #3a3a3a;
  }

  .search-mobile .search-content {
    background: #1a1a1a;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .card-item {
    background: #2a2a2a;
    border: 1px solid #3a3a3a;
  }

  .card-label { color: #909399; }
  .card-value { color: #e6a23c; }
  .card-actions { border-top-color: #3a3a3a; }

  .statistics-box { background: #2a2a2a; border: 1px solid #3a3a3a; }
  .detail-item { background: #3a3a3a; }

  /* 弹窗暗色模式 */
  .form-dialog .el-dialog {
    background: #2a2a2a !important;
  }

  .form-dialog .el-dialog__header {
    background: #2a2a2a !important;
    border-bottom: 1px solid #3a3a3a;
  }

  .form-dialog .el-dialog__title {
    color: #e6a23c !important;
  }

  .form-dialog .el-dialog__body {
    background: #1a1a1a !important;
  }

  .form-dialog .el-form-item__label {
    color: #909399 !important;
  }

  .form-dialog .el-input__wrapper,
  .form-dialog .el-select__wrapper,
  .form-dialog .el-textarea__inner {
    background: #2a2a2a !important;
    border-color: #3a3a3a !important;
  }

  .form-dialog .el-input__inner,
  .form-dialog .el-textarea__inner {
    color: #e6a23c !important;
  }

  .form-dialog .el-dialog__footer {
    background: #2a2a2a !important;
    border-top: 1px solid #3a3a3a;
  }
}
</style>
